<template>
    <div class="notes-editor">
        <TotemToast ref="toast" />
        <TotemButton color="secondary" icon="arrow-right" iconPosition="right" @click="goToCourse" :disabled="!editable" :label="$t('MemoPageNotesEditor.go_to_course')" v-if="isMobileView" />
        <div class="notes-editor__buttons-top">
            <TotemButton color="secondary" icon="arrow-right" iconPosition="right" @click="goToCourse" :disabled="!editable" :label="$t('MemoPageNotesEditor.go_to_course')" v-if="isDesktopView" />
            <TotemButton color="secondary" @click="deleteNote" :disabled="!editable" :label="$t('MemoPageNotesEditor.remove_note')" />
            <TotemButton color="primary" @click="saveNote" :disabled="!editable" :label="$t('MemoPageNotesEditor.save_note')" />
        </div>
        <TotemEditor :height="333" :content="currentNote" v-model="finalNote" :editable="editable" />
    </div>
</template>

<script>
    export default {
        props: {
            note: Object,
            editable: Boolean
        },
        data () {
            return {
                currentNote: null,
                finalNote: null,
                checkingMemoNotes: null
            }
        },
        watch: {
            note (newVal) {
                if (newVal) {
                    this.currentNote = newVal.content
                    this.finalNote = newVal.content
                } else {
                    this.currentNote = ''
                    this.finalNote = ''
                }
            }
        },
        methods: {
            onNoteSaved () {
                this.$refs.toast.show(this.$t('MemoPageNotesEditor.note_saved'))
            },
            onNoteDeleted () {
                this.$refs.toast.show(this.$t('MemoPageNotesEditor.note_removed'))
            },
            saveNote () {
                this.$emit('saveNote')
            },
            deleteNote () {
                this.$emit('deleteNote')
            },
            getContentOfNote () {
                return this.finalNote
            },
            goToCourse () {
                this.$emit('goToCourse')
            },
            autoSaveNote () {
                let lastNote = this.currentNote
                this.checkingMemoNotes = setInterval(() => {
                    if (lastNote !== this.finalNote) {
                        this.$emit('autoSaveNote')
                        lastNote = this.finalNote
                    }
                }, 5000)
            }
        },
        created () {
            this.autoSaveNote()
        },
        beforeDestroy () {
            clearInterval(this.checkingMemoNotes)
        }
    }
</script>

<style lang="scss">
    .notes-editor {
        position: relative;

        &__buttons-top {
            margin: 0 0 10px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 10px;

            [class*="mobile"] & {
                justify-content: flex-start;
                margin: 10px 0;
            }
        }

        &__notes-list {
            [class*="mobile"] & {
                margin: 0 0 10px;
            }
        }
    }
</style>
